module.exports = __webpack_public_path__ + "img/octo.5f0167e8.png";